import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import { customStyle } from 'helper';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateModal({
  createLowerCaseInput,
  createUserManagement,
  formData,
  getUserManagementList,
  history,
  showUserManagement,
  createUploader,
  createInputMobileNumber,
  createTelephoneNumber,
  getRoleList,
  roleList,
  setFormData,
  creating,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (_.isObject(formData.photo)) {
      const args = {
        ...formData,
        photo: formData.photo.cdnUrl,
        is_active: 1,
      };

      createUserManagement(args, ({ data }) => {
        setModal({ isOpen: false });
        getUserManagementList();
        history.push(`/user-management/employee/${_.get(data, 'id')}`);
        showUserManagement(data.id);
      });
    }
    if (!_.isObject(formData.photo)) {
      createUserManagement(formData, ({ data }) => {
        setModal({ isOpen: false });
        getUserManagementList();
        history.push(`/user-management/employee/${_.get(data, 'id')}`);
        showUserManagement(data.id);
      });
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };
  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  useEffect(() => {
    getRoleList();
  }, []);

  const roleOptions = roleList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row d-flex justify-content-center">
          <div className="col-4">
            <img
              className="w-100 rounded"
              src={
                !_.isObject(_.get(formData, 'photo') || '')
                  ? _.get(formData, 'photo') || ImagePlaceholder
                  : _.get(formData, 'photo.cdnUrl') || ImagePlaceholder
              }
              alt=""
            />
          </div>
        </div>
        <div className="row d-flex justify-content-center">
          <div className="col-4 form-group">
            {createUploader(
              { key: 'photo', label: 'Browse' },
              { required: true, crop: '1:1' }
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-6 form-grousp">
            {createLowerCaseInput(
              { key: 'first_name', label: 'First Name:' },
              { required: true, placeholder: 'First Name' }
            )}
          </div>
          <div className="col-6 form-group">
            {createLowerCaseInput(
              { key: 'last_name', label: 'Last Name:' },
              { required: true, placeholder: 'Last Name' }
            )}
          </div>
          <div className="col-6 form-group">
            {createLowerCaseInput(
              { key: 'password', label: 'Password' },
              { required: true, placeholder: 'Password', type: 'password' }
            )}
          </div>
          <div className="col-6 form-group">
            {createInputMobileNumber(
              { key: 'mobile_number', label: 'Mobile No.:' },
              { required: true, placeholder: 'Mobile No.' }
            )}
          </div>
          <div className="col-6 form-group">
            {createTelephoneNumber(
              { key: 'telephone_number', label: 'Telephone No.:' },
              { required: true, placeholder: 'Telephone No.' }
            )}
          </div>
          <div className="col-6 form-group">
            {createLowerCaseInput(
              { key: 'email', label: 'Email:' },
              { required: true, type: 'email', placeholder: 'Email Address' }
            )}
          </div>
          <div className="col-12 form-group">
            {createLowerCaseInput(
              { key: 'address', label: 'Address:' },
              { required: true, placeholder: 'Address' }
            )}
          </div>
          <div className="col-12 form-group">
            <Select
              styles={customStyle}
              placeholder="Select Role"
              onChange={handleOnChangeSelect('role_id')}
              options={roleOptions}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  createLowerCaseInput: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  getUserManagementList: PropTypes.instanceOf(Function).isRequired,
  createUserManagement: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  createInputMobileNumber: PropTypes.instanceOf(Function).isRequired,
  createTelephoneNumber: PropTypes.instanceOf(Function).isRequired,
  roleList: PropTypes.instanceOf(Array).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_USER_MANAGEMENT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
